import { Action } from '@ngrx/store';
import { TrackedRide } from '@polaris-customerweb/sharedcomponents.user-content';

export const TrackedRideAction = {
    deleteTrackedRide: '[tracked ride] delete tracked ride',
    forceTrackedRideRefresh: '[tracked ride] refresh on next pull',
    setActiveTrackedRide: '[tracked ride] set active tracked ride',
    setIsTrackedRideEditing: '[tracked ride] set is editing tracked ride',
    setTrackedRides: '[tracked ride] set tracked rides',
    toggleActiveTrackedRide: '[tracked ride] toggle active tracked ride',
    updateTrackedRide: '[tracked ride] update tracked ride',
};

export class DeleteTrackedRide implements Action {
    type = TrackedRideAction.deleteTrackedRide;
    constructor(public trackedRideId: string) {}
}

export class ForceTrackedRideRefresh implements Action {
    type = TrackedRideAction.forceTrackedRideRefresh;
    constructor(public forceRefresh: boolean) {}
}

export class SetActiveTrackedRide implements Action {
    type = TrackedRideAction.setActiveTrackedRide;
    constructor(public trackedRide: TrackedRide | undefined) {}
}

export class SetTrackedRides implements Action {
    type = TrackedRideAction.setTrackedRides;
    constructor(public trackedRides: TrackedRide[]) {}
}

export class ToggleActiveTrackedRide implements Action {
    type = TrackedRideAction.toggleActiveTrackedRide;
    constructor(public trackedRide: TrackedRide) {}
}

export class UpdateTrackedRide implements Action {
    type = TrackedRideAction.updateTrackedRide;
    constructor(public trackedRide: TrackedRide) {}
}

export class SetIsTrackedRideEditing implements Action {
    type = TrackedRideAction.setIsTrackedRideEditing;
    constructor(public isTrackedRideEditing: boolean) {}
}
